const { withLoading } = require('../utils/withLoading');

// this plugin adds a loading helper to Vue instances
// it allows you to wrap any function with a loading state
export default {
  install(Vue) {
    Vue.prototype.$withLoading = function (key, fn) {
      return withLoading(this, key, fn);
    };
  },
};
